<template>
  <wrap-container>
    <help-title title="Baja de productos" />

    <help-list-container>
      <help-list-item tituloLista="¿Cómo realizar la baja?">
        Los titulares pueden dar de baja sus productos desde
        <a id="contactForm" href="https://www.bbva.com.ar">Banca Online</a
        >:<br />
        - Clickeá en <strong>"Banca Online"</strong> ubicado en el margen
        superior derecho de la pantalla.<br />
        - Ingresá con tu DNI, Usuario y Clave Digital.
      </help-list-item>

      <help-list-item tituloLista="Para solicitar baja de Tarjeta:">
        - Seleccioná la tarjeta (débito/crédito).<br />
        - Hacé clic en la solapa <strong>"Operaciones"</strong>.<br />
        - Presioná <strong>"Pedir la baja"</strong>.
      </help-list-item>

      <help-list-item tituloLista="Para solicitar baja de Paquete:">
        Realiza el pedido de baja de cada una de las cuentas que componen el
        Paquete.<br />
        - Seleccioná la cuenta.<br />
        - Hacé clic en <strong>"Operaciones"</strong>.<br />
        - Presioná <strong>"Pedir la baja"</strong>.
      </help-list-item>

      <help-list-item
        tituloLista="Para solicitar baja de Caja de Ahorro en dólares / euros:"
      >
        - Seleccioná la cuenta.<br />
        - Hacé clic en <strong>"Operaciones"</strong>.<br />
        - Presioná <strong>"Pedir la baja"</strong>.
      </help-list-item>

      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad. También podes acercarte a tu Sucursal.
        <p id="contactForm" @click="contacto">Quiero que me contacten</p>
        <div v-if="show">
          <br />
          <formulario-contacto />
        </div>
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    FormularioContacto
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    contacto: function() {
      this.show = true;
    }
  }
};
</script>

<style>
#contactForm {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
</style>
